module.exports = __webpack_public_path__ + "static/media/guardian-network-group-en.d0d67b6a.webp";